export const defaultStyle = {
    content: 'section-wrapper flex flex-col space-y-[140px] self-end text-center items-center mb-[80px] lg:space-y-[24px] lg:self-center lg:text-left lg:items-start lg:mb-0',
    heading: 'headline1 text-white',
    cta: 'button-secondary w-full md:max-w-max md:min-w-[400px]',
}
